import { ChangeDetectionStrategy, Component, effect, inject, input, output } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import {
  ORGANIZATION_STATUS_LABEL,
  ORGANIZATION_STATUS_OPTIONS,
} from '../../../../../Consts/backoffice.const';
import { OrganizationFilters } from '../../../Interfaces/organization-filters.interface';
import { PlanSummary } from '../../../../../Models/backoffice/plan-summary.model';

@Component({
  selector: 'av-organization-filters',
  standalone: true,
  imports: [ReactiveFormsModule, MatIconModule, TranslateModule],
  templateUrl: './organization-filters.component.html',
  styleUrl: './organization-filters.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'd-block' },
})
export class OrganizationFiltersComponent {
  private readonly _formBuilder = inject(FormBuilder);

  readonly value = input.required<OrganizationFilters>();
  readonly plans = input.required<PlanSummary[]>();
  readonly disabled = input<boolean>(false);

  readonly filtersChange = output<OrganizationFilters>();
  readonly resetFilters = output<void>();

  readonly statusOptions = ORGANIZATION_STATUS_OPTIONS;
  readonly statusLabelKeys = ORGANIZATION_STATUS_LABEL;

  readonly formGroup: FormGroup = this._formBuilder.group({
    search: [''],
    status: [''],
    plan_id: [''],
  });

  constructor() {
    this._registerValueSync();
  }

  submit(): void {
    if (!this.formGroup.valid) {
      return;
    }

    this.filtersChange.emit({
      search: String(this.formGroup.value.search ?? '').trim(),
      status: String(this.formGroup.value.status ?? ''),
      plan_id: String(this.formGroup.value.plan_id ?? ''),
      tenant_health_status: this.value().tenant_health_status,
    });
  }

  reset(): void {
    this.formGroup.reset({ search: '', status: '', plan_id: '' });
    this.resetFilters.emit();
  }

  private _registerValueSync(): void {
    effect(() => {
      const filters = this.value();

      this._patchForm(filters);
    });
  }

  private _patchForm(filters: OrganizationFilters): void {
    this.formGroup.patchValue(
      { search: filters.search, status: filters.status, plan_id: filters.plan_id },
      { emitEvent: false },
    );
  }
}
